<template>
  <JobsLayout>
    <template #content>
      <main class="text-center q-pa-md flex flex-center">
        <section>
          <h1 class="q-my-sm" style="font-size: 20vh">
            {{ $t("JOBS.500.@TITLE") }}
          </h1>

          <h2 class="text-h2" style="opacity: 0.4">
            {{ $t("JOBS.500.@MESSAGE") }}
          </h2>

          <QBtn class="q-mt-xl" :to="searchRoute" :label="$t('JOBS.500.@ACTION')" no-caps />
        </section>
      </main>
    </template>
  </JobsLayout>
</template>

<script>
  import { JOBS_ROUTES } from "@jobs/config";
  import { MetaHelpers } from "@core/helpers";

  import JobsLayout from "@jobs/layouts/Jobs.layout.vue";

  export default {
    name: "Error500",
    components: {
      JobsLayout,
    },
    meta() {
      return MetaHelpers.setAutoMeta({
        title: this.$t("JOBS.500.@META_TITLE"),
        description: this.$t("JOBS.500.@META_DESCRIPTION"),
        noIndex: true,
      });
    },
    created() {
      this.homeRoute = { name: JOBS_ROUTES.public.home.name };
    },
  };
</script>
